import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=30283292&scoped=true&"
import script from "./IconCheck.vue?vue&type=script&lang=ts&"
export * from "./IconCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30283292",
  null
  
)

export default component.exports